import React, { useState, useEffect } from 'react';
import { CaretDownFilled, CaretUpFilled, DeleteFilled, } from '@ant-design/icons';
import { CustomHotelBedIcon, InfoIcon, WarningIcon, } from '../../../assets/icons';
import { AgeDropdown } from '../../Global';
export function OptionsComponent({ formik, toggleOverlay, toggleDropdown, closeDropdown, isOpen, }) {
    const { setFieldValue } = formik;
    const [rooms, setRooms] = useState([
        {
            adults: 1,
            children: 0,
            childrenAges: [],
            isOpen: true,
            isAgeDropdownOpen: [],
        },
    ]);
    const [errorAges, setErrorAges] = useState(false);
    const [travelersTotal, setTravelersTotal] = useState(1);
    const MAX_ROOMS = 8;
    const MAX_TRAVELERS = 9;
    useEffect(() => {
        const updatedRooms = rooms.map((room) => ({
            qtnAdt: room.adults,
            qtdInf: room.children,
            idadeInfant: room.childrenAges,
            qntBebe: 0,
        }));
        setFieldValue('qntRoom', updatedRooms);
    }, [rooms, setFieldValue]);
    const handleIncrement = (field, roomIndex) => {
        const updatedRooms = [...rooms];
        if (travelersTotal < MAX_TRAVELERS) {
            if (field === 'adults') {
                updatedRooms[roomIndex].adults += 1;
                setRooms(updatedRooms);
                const babiesCount = updatedRooms[roomIndex].childrenAges.filter((age) => age !== null && age < 2).length;
                if (babiesCount <= updatedRooms[roomIndex].adults) {
                    setErrorAges(false);
                }
            }
            if (field === 'children') {
                updatedRooms[roomIndex].children += 1;
                updatedRooms[roomIndex].childrenAges.push(0); // ainda não temos a idade
                updatedRooms[roomIndex].isAgeDropdownOpen.push(false);
                setRooms(updatedRooms);
                const babiesCount = updatedRooms[roomIndex].childrenAges.filter((age) => age !== null && age < 2).length;
                if (babiesCount > updatedRooms[roomIndex].adults) {
                    setErrorAges(true);
                }
            }
        }
    };
    const handleDecrement = (field, roomIndex) => {
        const updatedRooms = [...rooms];
        if (field === 'adults' && updatedRooms[roomIndex].adults > 1) {
            updatedRooms[roomIndex].adults -= 1;
            const babiesCount = updatedRooms[roomIndex].childrenAges.filter((age) => age !== null && age < 2).length;
            if (babiesCount > updatedRooms[roomIndex].adults) {
                setErrorAges(true);
            }
            else {
                setErrorAges(false);
            }
            setRooms(updatedRooms);
        }
        if (field === 'children' && updatedRooms[roomIndex].children > 0) {
            updatedRooms[roomIndex].children -= 1;
            updatedRooms[roomIndex].childrenAges.pop();
            updatedRooms[roomIndex].isAgeDropdownOpen.pop();
            const babiesCount = updatedRooms[roomIndex].childrenAges.filter((age) => age !== null && age <= 2).length;
            if (babiesCount <= updatedRooms[roomIndex].adults) {
                setErrorAges(false);
            }
            setRooms(updatedRooms);
        }
    };
    const handleAgeChange = (age, index, roomIndex) => {
        const updatedRooms = [...rooms];
        const updatedAges = [...updatedRooms[roomIndex].childrenAges];
        updatedAges[index] = age;
        const updatedDropdowns = [...updatedRooms[roomIndex].isAgeDropdownOpen];
        updatedDropdowns[index] = false;
        updatedRooms[roomIndex].childrenAges = updatedAges;
        updatedRooms[roomIndex].isAgeDropdownOpen = updatedDropdowns;
        const babiesCount = updatedRooms[roomIndex].childrenAges.filter((age) => age !== null && age <= 2).length;
        const adultsCount = updatedRooms[roomIndex].adults;
        if (babiesCount > adultsCount) {
            setErrorAges(true);
            return;
        }
        else {
            setErrorAges(false);
        }
        setRooms(updatedRooms);
    };
    const toggleRoom = (index) => {
        const updatedRooms = [...rooms];
        updatedRooms[index].isOpen = !updatedRooms[index].isOpen;
        setRooms(updatedRooms);
    };
    const removeRoom = (index) => {
        const updatedRooms = rooms.filter((_, i) => i !== index);
        setRooms(updatedRooms);
    };
    const addRoom = () => {
        if (rooms.length < MAX_ROOMS) {
            setRooms([
                ...rooms,
                {
                    adults: 1,
                    children: 0,
                    childrenAges: [],
                    isOpen: false,
                    isAgeDropdownOpen: [],
                },
            ]);
        }
    };
    const handleCLick = () => {
        formik.setFieldTouched('adults', true);
        toggleOverlay(true);
    };
    const toggleAgeDropdown = (childIndex, roomIndex) => {
        const updatedRooms = [...rooms];
        updatedRooms[roomIndex].isAgeDropdownOpen[childIndex] =
            !updatedRooms[roomIndex].isAgeDropdownOpen[childIndex];
        setRooms(updatedRooms);
    };
    const totalTravelers = rooms.reduce((total, room) => total + room.adults + room.children, 0);
    const totalChildrens = rooms.reduce((totalRooms, room) => totalRooms + room.children, 0);
    const totalRooms = rooms.length;
    useEffect(() => {
        setTravelersTotal(totalTravelers);
    }, [totalTravelers]);
    return (React.createElement("section", { className: "relative inline-block mb-6", onClick: handleCLick },
        React.createElement("header", { className: "flex items-center gap-2 max-w-fit cursor-pointer justify-between bg-white", onClick: toggleDropdown },
            React.createElement(CustomHotelBedIcon, { className: "text-[#ff7020]" }),
            React.createElement("span", { className: "text-black font-bold text-[14px]" },
                totalTravelers,
                " ",
                totalTravelers === 1 ? 'viajante' : 'viajantes',
                ",",
                ' ',
                totalRooms,
                " ",
                totalRooms > 1 ? 'quartos' : 'quarto'),
            React.createElement("span", { className: "text-gray-500 text-xs" }, isOpen ? (React.createElement(CaretUpFilled, { className: "text-black" })) : (React.createElement(CaretDownFilled, { className: "text-black" })))),
        React.createElement("div", { className: `absolute mt-2 w-[280px] bg-white rounded-xl shadow-2xl p-4 z-10 transition-opacity duration-300 ease-in-out ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`, onClick: (e) => e.stopPropagation() },
            rooms.map((room, index) => (React.createElement("div", { key: index },
                React.createElement("div", { className: "flex justify-between items-center py-2 text-black" },
                    React.createElement("span", { className: "font-semibold" }, `Quarto ${index + 1}`),
                    React.createElement("div", { className: "flex gap-4" },
                        rooms.length > 1 && index !== 0 && (React.createElement("button", { type: "button", onClick: () => removeRoom(index), className: "flex items-center" },
                            React.createElement("span", { className: "ml-1" },
                                React.createElement(DeleteFilled, null)))),
                        React.createElement("button", { type: "button", className: "text-gray-500", onClick: () => toggleRoom(index) }, room.isOpen ? React.createElement(CaretDownFilled, null) : React.createElement(CaretUpFilled, null)))),
                room.isOpen && (React.createElement("section", { className: "flex flex-col gap-4 text-black" },
                    React.createElement("div", { className: "flex justify-between items-center py-2" },
                        React.createElement("span", { className: "font-semibold" }, "Pessoas adultas"),
                        React.createElement("div", { className: "flex items-center gap-2" },
                            React.createElement("button", { type: "button", onClick: () => handleDecrement('adults', index), className: "w-8 h-8 flex items-center justify-center rounded-md text-lg text-gray-600" }, "-"),
                            React.createElement("span", { className: "font-semibold" }, room.adults),
                            React.createElement("button", { type: "button", onClick: () => handleIncrement('adults', index), className: `w-8 h-8 flex items-center justify-center rounded-md text-lg text-gray-600 ${travelersTotal >= MAX_TRAVELERS ? 'disabled' : ''}`, disabled: travelersTotal >= MAX_TRAVELERS }, "+"))),
                    React.createElement("div", { className: "flex justify-between items-center py-2" },
                        React.createElement("div", null,
                            React.createElement("span", { className: "font-semibold" }, "Crian\u00E7as"),
                            React.createElement("p", { className: "text-xs text-gray-500" }, "0 a 17 anos")),
                        React.createElement("div", { className: "flex items-center gap-2" },
                            React.createElement("button", { type: "button", onClick: () => handleDecrement('children', index), className: "w-8 h-8 flex items-center justify-center rounded-md text-lg text-gray-600" }, "-"),
                            React.createElement("span", { className: "font-semibold" }, room.children),
                            React.createElement("button", { type: "button", onClick: () => handleIncrement('children', index), className: `w-8 h-8 flex items-center justify-center rounded-md text-lg text-gray-600 ${travelersTotal >= MAX_TRAVELERS ? 'disabled' : ''}`, disabled: travelersTotal >= MAX_TRAVELERS }, "+"))),
                    room.children > 0 && (React.createElement("div", { className: "flex flex-col gap-2" },
                        React.createElement("span", { className: "font-semibold" }, "Idade das crian\u00E7as"),
                        React.createElement("div", { className: "flex gap-4 items-center flex-wrap" }, Array.from({ length: room.children }).map((_, childIndex) => (React.createElement(AgeDropdown, { key: childIndex, ageOptions: Array.from({ length: 18 }, (_, i) => i), selectedAge: room.childrenAges[childIndex] || 0, isOpen: room.isAgeDropdownOpen[childIndex], onToggle: () => toggleAgeDropdown(childIndex, index), onSelectAge: (age) => handleAgeChange(age, childIndex, index), errorAges: errorAges }))))))))))),
            totalChildrens > 0 && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "bg-[#ded7d3] text-black text-sm rounded-xl px-4 py-3 mt-4 flex items-center gap-2 max-w-fit" },
                    React.createElement(InfoIcon, null),
                    React.createElement("span", null, "Considere a idade durante o per\u00EDodo da viagem")),
                React.createElement("div", { className: "bg-[#FFF0CC] text-[#7C3A00] text-sm p-4 mt-4 rounded-2xl flex items-start gap-2 w-fit" },
                    React.createElement(WarningIcon, { className: "p-2 pt-[20%]" }),
                    React.createElement("p", null,
                        "\u00C9 preciso ter pelo menos um adulto acompanhando cada beb\u00EA",
                        ' ',
                        React.createElement("strong", null, "(2 anos ou menos)"))))),
            React.createElement("footer", { className: "mt-4" },
                React.createElement("button", { type: "button", onClick: addRoom, className: `border-b text-black py-2 ${rooms.length >= MAX_ROOMS || travelersTotal >= MAX_TRAVELERS
                        ? 'disabled'
                        : ''}`, disabled: rooms.length >= 9 || travelersTotal >= MAX_TRAVELERS }, "Adicionar quarto"),
                React.createElement("button", { type: "button", onClick: closeDropdown, className: `w-full bg-[#ff7020] text-black py-2 rounded-lg font-semibold mt-2 ${errorAges ? 'disabled !bg-[#F2F2F2]' : ''}`, disabled: errorAges }, "Confirmar")))));
}
//# sourceMappingURL=index.js.map